import { addDays, startOfWeek, weekdayOf, type IsoDate } from "@habitos/shared";

export const WEEKDAY_SHORT = ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"];
export const WEEKDAY_LETTER = ["D", "L", "M", "X", "J", "V", "S"];
/** Display order: Monday first. */
export const WEEK_ORDER = [1, 2, 3, 4, 5, 6, 0];

const MONTHS = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

export function formatDay(date: IsoDate): string {
  const [, m, d] = date.split("-").map(Number);
  return `${WEEKDAY_SHORT[weekdayOf(date)]} ${d} ${MONTHS[(m ?? 1) - 1]}`;
}

export function relativeDayLabel(date: IsoDate, today: IsoDate): string {
  if (date === today) return "Hoy";
  if (date === addDays(today, -1)) return "Ayer";
  if (date === addDays(today, 1)) return "Mañana";
  return formatDay(date);
}

export function weekDates(date: IsoDate): IsoDate[] {
  const monday = startOfWeek(date);
  return Array.from({ length: 7 }, (_, i) => addDays(monday, i));
}

export function describeDays(days: number[]): string {
  const set = new Set(days);
  if (set.size === 7) return "Todos los días";
  if (set.size === 5 && [1, 2, 3, 4, 5].every((d) => set.has(d))) return "Entre semana";
  if (set.size === 2 && set.has(0) && set.has(6)) return "Fines de semana";
  return WEEK_ORDER.filter((d) => set.has(d)).map((d) => WEEKDAY_SHORT[d]).join(", ");
}

/** "45 min", "3 h", "1 h 30 min": long blocks read better in hours. */
export function formatDuration(minutes: number): string {
  if (minutes < 60) return `${minutes} min`;
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return m ? `${h} h ${m} min` : `${h} h`;
}
